import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const getModalConfig = (width) => {
  if (width < 576) {
    return { size: "sm", fullscreen: false };
  }

  if (width < 992) {
    return { size: undefined, fullscreen: false }; // medium/default
  }

  return { size: "lg", fullscreen: false };
};

const NewAdViewModal = ({ showModal, handleModal }) => {
  const navigate = useNavigate();

  const [modalConfig, setModalConfig] = useState(() =>
    getModalConfig(
      typeof window !== "undefined" ? window.innerWidth : 1200
    )
  );

  useEffect(() => {
    const handleResize = () => {
      setModalConfig(getModalConfig(window.innerWidth));
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = () => {
    handleModal(false);
    navigate("/fantastic");
  };

  return (
    <Modal
      show={showModal}
      onHide={() => handleModal(false)}
      size={modalConfig.size}
      fullscreen={modalConfig.fullscreen}
      centered
      contentClassName="border-0 bg-transparent"
    >
      <Modal.Body
        className="p-0 d-flex justify-content-center align-items-center"
        style={{
          overflow: "hidden",
          borderRadius: "16px",
        }}
      >
        <img
          src="/assets/images/ad1.png"
          alt="Advertisement"
          onClick={handleClick}
          style={{
            width: "100%",
            maxWidth: "900px",
            height: "auto",
            display: "block",
            objectFit: "cover",
            borderRadius: "16px",
            cursor: "pointer",
          }}
        />
      </Modal.Body>
    </Modal>
  );
};

export default NewAdViewModal;